<template>
  <div v-if="status" class="has-tooltip">
    <img :src="src" class="w-6 h-6" />
    <span class="tooltip">{{ status.verbose }}</span>
  </div>
</template>

<script>
export default {
  name: 'StatusChip',
  props: {
    status: Object
  },
  computed: {
    src () {
      const pngs = require.context('@/assets/images/', false, /\.png$/)
      const src = pngs(`./${this.status.class}.png`) || ''
      return src
    }
  }
}
</script>
